mutation Inertia_ReplaceDocument($documentId: ID!, $fileId: ID!) {
  replaceDocument(input: { documentId: $documentId, fileId: $fileId }) {
    document {
      id
      name
      updatedAt
    }
    errors
  }
}